(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shadow-boxing"] && !Shopify.designMode) return;
  try {
    
(() => {
  const STORAGE = {
    player: 'tc32_bm_player',
    ranking: 'tc32_bm_ranking',
    muted: 'tc32_bm_muted'
  };

  const MOVES = {
    jab_l: {
      label: 'JAB IZQ.',
      side: 'left',
      animation: 'jab-l'
    },
    cross_r: {
      label: 'RECTO DER.',
      side: 'right',
      animation: 'cross-r'
    },
    hook_l: {
      label: 'GANCHO IZQ.',
      side: 'left',
      animation: 'hook-l'
    },
    hook_r: {
      label: 'GANCHO DER.',
      side: 'right',
      animation: 'hook-r'
    },
    upper_l: {
      label: 'UPPER IZQ.',
      side: 'left',
      animation: 'upper-l'
    },
    upper_r: {
      label: 'UPPER DER.',
      side: 'right',
      animation: 'upper-r'
    }
  };

  const wait = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

  const get = (key, fallback = '') => {
    try {
      return localStorage.getItem(key) ?? fallback;
    } catch (error) {
      return fallback;
    }
  };

  const set = (key, value) => {
    try {
      localStorage.setItem(key, value);
    } catch (error) {}
  };

  const parseJSON = (value, fallback) => {
    try {
      return JSON.parse(value);
    } catch (error) {
      return fallback;
    }
  };

  class SoundFX {
    constructor(root) {
      this.root = root;
      this.muted = get(STORAGE.muted, 'false') === 'true';
      this.context = null;
    }

    async unlock() {
      if (!this.context) {
        this.context = new (window.AudioContext || window.webkitAudioContext)();
      }

      if (this.context.state === 'suspended') {
        await this.context.resume();
      }
    }

    tone(frequency, duration, volume, type = 'square', delay = 0) {
      if (!this.context || this.muted) return;

      const start = this.context.currentTime + delay;
      const oscillator = this.context.createOscillator();
      const gain = this.context.createGain();

      oscillator.type = type;
      oscillator.frequency.value = frequency;

      gain.gain.setValueAtTime(volume, start);
      gain.gain.exponentialRampToValueAtTime(0.0001, start + duration);

      oscillator.connect(gain).connect(this.context.destination);
      oscillator.start(start);
      oscillator.stop(start + duration);
    }

    noise(duration = 0.08, volume = 0.12, frequency = 900) {
      if (!this.context || this.muted) return;

      const buffer = this.context.createBuffer(
        1,
        Math.ceil(this.context.sampleRate * duration),
        this.context.sampleRate
      );

      const data = buffer.getChannelData(0);

      for (let index = 0; index < data.length; index += 1) {
        data[index] = Math.random() * 2 - 1;
      }

      const source = this.context.createBufferSource();
      const filter = this.context.createBiquadFilter();
      const gain = this.context.createGain();
      const start = this.context.currentTime;

      source.buffer = buffer;
      filter.type = 'bandpass';
      filter.frequency.value = frequency;

      gain.gain.setValueAtTime(volume, start);
      gain.gain.exponentialRampToValueAtTime(0.0001, start + duration);

      source.connect(filter).connect(gain).connect(this.context.destination);
      source.start(start);
    }

    countdown(number) {
      this.tone(300 + (3 - number) * 70, 0.11, 0.14, 'square');
    }

    start() {
      this.tone(420, 0.45, 0.12, 'triangle');
      this.tone(620, 0.4, 0.09, 'triangle', 0.03);
    }

    punch(move) {
      this.noise(0.075, 0.15, move.includes('upper') ? 650 : 950);
      this.tone(move.includes('hook') ? 170 : 220, 0.08, 0.08, 'sawtooth');
    }

    correct() {
      this.tone(650, 0.08, 0.1, 'square');
      this.tone(820, 0.09, 0.08, 'square', 0.07);
    }

    error() {
      this.tone(130, 0.38, 0.18, 'sawtooth');
      this.noise(0.22, 0.2, 320);
    }
  }

  class BoxingMemory {
    constructor(root) {
      if (root.dataset.ready) return;

      root.dataset.ready = '1';
      this.root = root;
      this.soundFX = new SoundFX(root);
      this.phase = 'idle';
      this.sequence = [];
      this.playerIndex = 0;
      this.totalMoves = 0;
      this.score = 0;
      this.round = 0;
      this.lastEntry = null;

      const query = (selector) => root.querySelector(selector);

      this.elements = {
        intro: query('[data-intro]'),
        game: query('[data-game]'),
        results: query('[data-results]'),
        form: query('[data-form]'),
        name: query('[data-name]'),
        sound: query('[data-sound]'),
        retry: query('[data-retry]'),
        share: query('[data-share]'),
        shareNote: query('[data-share-note]'),
        clear: query('[data-clear]'),
        ranking: query('[data-ranking]'),
        empty: query('[data-empty]'),
        live: query('[data-live]'),
        status: query('[data-status]'),
        sequenceView: query('[data-sequence]'),
        countdown: query('[data-countdown]'),
        fighter: query('[data-fighter]'),
        leftArm: query('[data-arm-left]'),
        rightArm: query('[data-arm-right]'),
        impact: query('[data-impact]'),
        controls: query('[data-controls]'),
        buttons: [...root.querySelectorAll('[data-punch]')],
        round: query('[data-round]'),
        length: query('[data-length]'),
        moves: query('[data-moves]'),
        score: query('[data-score]'),
        kicker: query('[data-kicker]'),
        resultTitle: query('[data-result-title]'),
        reason: query('[data-reason]'),
        resultName: query('[data-r-name]'),
        resultRound: query('[data-r-round]'),
        resultMoves: query('[data-r-moves]'),
        resultScore: query('[data-r-score]'),
        record: query('[data-record]')
      };

      this.elements.name.value = get(STORAGE.player);
      this.bind();
      this.renderRanking();
      this.renderSound();
      this.setControls(false);
    }

    bind() {
      this.elements.form.addEventListener('submit', (event) => {
        event.preventDefault();
        this.start();
      });

      this.elements.retry.addEventListener('click', () => this.start());

      this.elements.sound.addEventListener('click', async () => {
        this.soundFX.muted = !this.soundFX.muted;
        set(STORAGE.muted, String(this.soundFX.muted));

        if (!this.soundFX.muted) {
          await this.soundFX.unlock().catch(() => {});
        }

        this.renderSound();
      });

      this.elements.buttons.forEach((button) => {
        button.addEventListener('pointerdown', (event) => {
          event.preventDefault();

          if (this.phase !== 'input') return;

          this.handlePlayerMove(button.dataset.punch);
        });
      });

      this.elements.clear.addEventListener('click', () => {
        if (confirm('¿Borrar todos los resultados locales de Boxing Memory?')) {
          set(STORAGE.ranking, '[]');
          this.renderRanking();
        }
      });

      this.elements.share.addEventListener('click', () => this.shareRecord());

      document.addEventListener('visibilitychange', () => {
        if (document.hidden && ['demo', 'input', 'countdown'].includes(this.phase)) {
          this.fail('La ventana perdió el enfoque.');
        }
      });

      window.addEventListener('blur', () => {
        if (['demo', 'input'].includes(this.phase)) {
          this.fail('La ventana perdió el enfoque.');
        }
      });
    }

    renderSound() {
      this.elements.sound.setAttribute('aria-pressed', String(this.soundFX.muted));
      this.elements.sound.innerHTML = this.soundFX.muted
        ? '<span aria-hidden="true">◖×</span> SILENCIO'
        : '<span aria-hidden="true">◖))</span> SONIDO';
    }

    async start() {
      if (['countdown', 'demo', 'input'].includes(this.phase)) return;

      const name = this.elements.name.value
        .trim()
        .replace(/\s+/g, ' ')
        .slice(0, 18)
        .toUpperCase();

      if (!name) {
        this.elements.name.focus();
        return;
      }

      this.player = name;
      set(STORAGE.player, name);

      await this.soundFX.unlock().catch(() => {});

      this.reset();
      this.elements.intro.hidden = true;
      this.elements.results.hidden = true;
      this.elements.game.hidden = false;
      this.elements.game.scrollIntoView({ behavior: 'smooth', block: 'start' });

      this.phase = 'countdown';
      this.elements.status.textContent = 'PREPÁRATE';

      for (const number of [3, 2, 1]) {
        this.elements.countdown.textContent = number;
        this.elements.countdown.classList.remove('pop');
        void this.elements.countdown.offsetWidth;
        this.elements.countdown.classList.add('pop');
        this.soundFX.countdown(number);
        await wait(360);
      }

      this.elements.countdown.textContent = '';

      if (this.phase !== 'countdown') return;

      this.soundFX.start();
      await wait(300);
      this.nextRound();
    }

    reset() {
      this.phase = 'idle';
      this.sequence = [];
      this.playerIndex = 0;
      this.totalMoves = 0;
      this.score = 0;
      this.round = 0;
      this.lastEntry = null;
      this.elements.round.textContent = '1';
      this.elements.length.textContent = '1';
      this.elements.moves.textContent = '0';
      this.elements.score.textContent = '0';
      this.elements.sequenceView.replaceChildren();
      this.elements.shareNote.textContent = '';
      this.elements.leftArm.className = 'bm__arm bm__arm--left';
      this.elements.rightArm.className = 'bm__arm bm__arm--right';
      this.elements.impact.classList.remove('show');
      this.setControls(false);
    }

    availableMoves(round) {
      if (round <= 3) return ['jab_l', 'cross_r'];
      if (round <= 6) return ['jab_l', 'cross_r', 'hook_l', 'hook_r'];
      return Object.keys(MOVES);
    }

    chooseMove() {
      const available = this.availableMoves(this.round);
      const last = this.sequence[this.sequence.length - 1];
      const secondLast = this.sequence[this.sequence.length - 2];

      let candidates = available;

      if (last && secondLast && last === secondLast) {
        candidates = available.filter((move) => move !== last);
      }

      return candidates[Math.floor(Math.random() * candidates.length)];
    }

    demoDelay() {
      if (this.round <= 5) return 760;
      if (this.round <= 10) return 650;
      if (this.round <= 15) return 540;
      if (this.round <= 20) return 450;
      return 360;
    }

    async nextRound() {
      this.round += 1;
      this.sequence.push(this.chooseMove());
      this.playerIndex = 0;

      this.elements.round.textContent = this.round;
      this.elements.length.textContent = this.sequence.length;
      this.elements.status.textContent = 'OBSERVA LA COMBINACIÓN';
      this.setControls(false);
      this.renderSequence('demo');

      await wait(650);

      this.phase = 'demo';

      for (let index = 0; index < this.sequence.length; index += 1) {
        if (this.phase !== 'demo') return;

        this.highlightSequence(index, 'demo');
        await this.animatePunch(this.sequence[index], true);
        await wait(Math.max(120, this.demoDelay() - 360));
      }

      if (this.phase !== 'demo') return;

      this.clearSequenceHighlights();
      this.phase = 'input';
      this.elements.status.textContent = 'TU TURNO';
      this.renderSequence('input');
      this.setControls(true);
      this.elements.live.textContent = 'Tu turno. Repite la combinación.';
    }

    renderSequence(mode) {
      this.elements.sequenceView.replaceChildren();

      this.sequence.forEach((move, index) => {
        const item = document.createElement('span');

        if (mode === 'demo') {
          item.textContent = MOVES[move].label;
        } else {
          item.textContent = String(index + 1).padStart(2, '0');
        }

        item.dataset.index = index;
        this.elements.sequenceView.appendChild(item);
      });
    }

    highlightSequence(index, mode) {
      const items = [...this.elements.sequenceView.children];

      items.forEach((item, itemIndex) => {
        item.classList.toggle('active', itemIndex === index);

        if (mode === 'input') {
          item.classList.toggle('done', itemIndex < index);
        }
      });
    }

    clearSequenceHighlights() {
      [...this.elements.sequenceView.children].forEach((item) => {
        item.classList.remove('active', 'done');
      });
    }

    setControls(enabled) {
      this.elements.buttons.forEach((button) => {
        button.disabled = !enabled;
      });
    }

    async handlePlayerMove(move) {
      if (this.phase !== 'input') return;

      const expected = this.sequence[this.playerIndex];
      const button = this.elements.buttons.find(
        (item) => item.dataset.punch === move
      );

      if (button) {
        button.classList.add('active');
        setTimeout(() => button.classList.remove('active'), 150);
      }

      await this.animatePunch(move, false);

      if (move !== expected) {
        this.fail(
          `Presionaste ${MOVES[move].label}. El movimiento correcto era ${MOVES[expected].label}.`
        );
        return;
      }

      this.playerIndex += 1;
      this.totalMoves += 1;
      this.score += this.calculateMoveScore();
      this.elements.moves.textContent = this.totalMoves;
      this.elements.score.textContent = this.score.toLocaleString('es-MX');
      this.highlightSequence(this.playerIndex, 'input');

      if (this.playerIndex >= this.sequence.length) {
        this.phase = 'between';
        this.setControls(false);
        this.soundFX.correct();
        this.elements.status.textContent = 'COMBINACIÓN COMPLETA';
        this.elements.live.textContent = `Ronda ${this.round} completada.`;

        await wait(900);

        if (this.phase !== 'between') return;

        this.nextRound();
      }
    }

    calculateMoveScore() {
      const speedMultiplier =
        this.round <= 5
          ? 1
          : this.round <= 10
            ? 1.2
            : this.round <= 15
              ? 1.4
              : this.round <= 20
                ? 1.7
                : 2;

      return Math.round(10 * this.round * speedMultiplier);
    }

    async animatePunch(move, demo) {
      const data = MOVES[move];
      const arm =
        data.side === 'left'
          ? this.elements.leftArm
          : this.elements.rightArm;

      const className = data.animation;

      arm.classList.remove(className);
      void arm.offsetWidth;
      arm.classList.add(className);

      this.elements.impact.classList.remove('show');
      void this.elements.impact.offsetWidth;
      this.elements.impact.classList.add('show');

      this.soundFX.punch(move);

      if (navigator.vibrate && !demo) {
        navigator.vibrate(18);
      }

      await wait(360);
      arm.classList.remove(className);
    }

    fail(reason) {
      if (!['countdown', 'demo', 'input', 'between'].includes(this.phase)) return;

      this.phase = 'ended';
      this.setControls(false);
      this.soundFX.error();

      if (navigator.vibrate) {
        navigator.vibrate([80, 40, 120]);
      }

      const completedRound = Math.max(0, this.round - 1);
      const entry = {
        name: this.player,
        round: completedRound,
        moves: this.totalMoves,
        score: this.score,
        date: Date.now()
      };

      const record = this.save(entry);
      this.lastEntry = entry;

      setTimeout(() => this.showResult(entry, reason, record), 450);
    }

    save(entry) {
      const ranking = parseJSON(get(STORAGE.ranking, '[]'), []);
      const best = ranking.length
        ? Math.max(...ranking.map((item) => Number(item.score) || 0))
        : -1;

      ranking.push(entry);

      ranking.sort(
        (a, b) =>
          b.score - a.score ||
          b.round - a.round ||
          b.moves - a.moves
      );

      set(STORAGE.ranking, JSON.stringify(ranking.slice(0, 10)));

      return entry.score > best;
    }

    showResult(entry, reason, record) {
      this.elements.game.hidden = true;
      this.elements.results.hidden = false;
      this.elements.kicker.textContent = 'FIN';
      this.elements.resultTitle.textContent = 'COMBINACIÓN FALLIDA';
      this.elements.reason.textContent = reason;
      this.elements.resultName.textContent = entry.name;
      this.elements.resultRound.textContent = entry.round;
      this.elements.resultMoves.textContent = entry.moves;
      this.elements.resultScore.textContent =
        entry.score.toLocaleString('es-MX');
      this.elements.record.hidden = !record;
      this.elements.live.textContent =
        `Partida terminada. Nivel ${entry.round}, ` +
        `${entry.moves} movimientos y ${entry.score} puntos.`;

      this.renderRanking();
      this.elements.results.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }

    async shareRecord() {
      if (!this.lastEntry) return;

      const entry = this.lastEntry;
      const url =
        this.root.dataset.shareUrl ||
        window.location.href.split('?')[0].split('#')[0];

      const text =
        `Llegué a la ronda ${entry.round} y memoricé ${entry.moves} movimientos ` +
        `en Boxing Memory de TC32, con una puntuación de ` +
        `${entry.score.toLocaleString('es-MX')}. ¡Te reto a superarme!`;

      const shareData = {
        title: 'Boxing Memory | TC32 Arcade',
        text,
        url
      };

      try {
        if (navigator.share) {
          await navigator.share(shareData);
          this.elements.shareNote.textContent = 'Récord listo para compartir.';
          return;
        }

        await navigator.clipboard.writeText(`${text} ${url}`);
        this.elements.shareNote.textContent =
          'Mensaje y enlace copiados al portapapeles.';
      } catch (error) {
        if (error && error.name === 'AbortError') return;

        const fallback = document.createElement('textarea');
        fallback.value = `${text} ${url}`;
        fallback.setAttribute('readonly', '');
        fallback.style.position = 'fixed';
        fallback.style.opacity = '0';
        document.body.appendChild(fallback);
        fallback.select();
        document.execCommand('copy');
        fallback.remove();

        this.elements.shareNote.textContent =
          'Mensaje y enlace copiados al portapapeles.';
      }
    }

    renderRanking() {
      const ranking = parseJSON(get(STORAGE.ranking, '[]'), []);
      this.elements.ranking.replaceChildren();
      this.elements.empty.hidden = ranking.length > 0;

      ranking.forEach((entry, index) => {
        const row = document.createElement('tr');
        const values = [
          index + 1,
          entry.name,
          entry.round,
          entry.moves,
          Number(entry.score).toLocaleString('es-MX')
        ];

        values.forEach((value) => {
          const cell = document.createElement('td');
          cell.textContent = value;
          row.appendChild(cell);
        });

        this.elements.ranking.appendChild(row);
      });
    }
  }

  const init = (scope) => {
    (scope || document)
      .querySelectorAll('[data-boxing-memory]')
      .forEach((root) => new BoxingMemory(root));
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => {
    init(event.target);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tc32-mitt-rush"] && !Shopify.designMode) return;
  try {
    
(()=>{const C={duration:180000,reactionStart:900,reactionStep:50,reactionMin:350,every:5,delay:850,step:60,min:220,grace:140},get=(k,d='')=>{try{return localStorage.getItem(k)??d}catch(e){return d}},set=(k,v)=>{try{localStorage.setItem(k,v)}catch(e){}},json=(v,d)=>{try{return JSON.parse(v)}catch(e){return d}},wait=m=>new Promise(r=>setTimeout(r,m)),clock=m=>{m=Math.max(0,m);return String(Math.floor(m/60000)).padStart(2,'0')+':'+String(Math.floor(m%60000/1000)).padStart(2,'0')+'.'+String(Math.floor(m%1000/10)).padStart(2,'0')};
class AudioFx{constructor(r){this.r=r;this.m=get('tc32_mr_muted','false')==='true';this.c=null}async unlock(){if(!this.c)this.c=new(window.AudioContext||window.webkitAudioContext)();if(this.c.state==='suspended')await this.c.resume()}ext(n){const u=this.r.dataset[n];if(!u||this.m)return false;const a=new Audio(u);a.volume=n==='crowd'?.75:.9;a.play().catch(()=>{});return true}tone(f,s,d,v,t='sine'){if(!this.c||this.m)return;const o=this.c.createOscillator(),g=this.c.createGain();o.type=t;o.frequency.value=f;g.gain.setValueAtTime(v,s);g.gain.exponentialRampToValueAtTime(.0001,s+d);o.connect(g).connect(this.c.destination);o.start(s);o.stop(s+d)}noise(s,d,v,f){if(!this.c||this.m)return;const b=this.c.createBuffer(1,Math.ceil(this.c.sampleRate*d),this.c.sampleRate),x=b.getChannelData(0);for(let i=0;i<x.length;i++)x[i]=Math.random()*2-1;const q=this.c.createBufferSource(),p=this.c.createBiquadFilter(),g=this.c.createGain();q.buffer=b;p.type='bandpass';p.frequency.value=f;g.gain.setValueAtTime(v,s);g.gain.exponentialRampToValueAtTime(.0001,s+d);q.connect(p).connect(g).connect(this.c.destination);q.start(s)}beep(n){if(this.c&&!this.m)this.tone(330+(3-n)*55,this.c.currentTime,.12,.16,'square')}bell(){if(this.ext('bell')||!this.c||this.m)return;const n=this.c.currentTime;[420,560,735,910].forEach((f,i)=>this.tone(f,n+i*.004,1.7-i*.12,.12/(i+1),'triangle'));this.noise(n,.16,.16,2400)}hit(t){if(this.ext('hit')||!this.c||this.m)return;const n=this.c.currentTime;this.noise(n,.075,.18,900);this.tone(t<=250?720:510,n,.09,.09,'square')}clacks(){if(this.ext('clacks')||!this.c||this.m)return;const n=this.c.currentTime;[0,.23,.46].forEach(o=>{this.noise(n+o,.06,.28,1750);this.tone(260,n+o,.05,.1,'square')})}ko(){if(this.ext('ko')||!this.c||this.m)return;const n=this.c.currentTime;this.noise(n,.25,.28,280);this.tone(105,n,.55,.26,'sawtooth')}crowd(){if(this.ext('crowd')||!this.c||this.m)return;const n=this.c.currentTime;for(let i=0;i<20;i++)this.noise(n+Math.random()*3.2,.4+Math.random()*.7,.05,500+Math.random()*1400)}}
class Game{constructor(r){if(r.dataset.ready)return;r.dataset.ready='1';this.r=r;this.a=new AudioFx(r);this.phase='idle';this.q=s=>r.querySelector(s);this.e={intro:this.q('[data-intro]'),game:this.q('[data-game]'),results:this.q('[data-results]'),form:this.q('[data-form]'),name:this.q('[data-name]'),arena:this.q('[data-arena]'),target:this.q('[data-target]'),count:this.q('[data-count]'),levelUp:this.q('[data-level-up]'),final:this.q('[data-final]'),time:this.q('[data-time]'),hits:this.q('[data-hits]'),level:this.q('[data-level]'),round:this.q('[data-round]'),feedback:this.q('[data-feedback]'),flash:this.q('[data-flash]'),confetti:this.q('[data-confetti]'),sound:this.q('[data-sound]'),retry:this.q('[data-retry]'),clear:this.q('[data-clear]'),ranking:this.q('[data-ranking]'),empty:this.q('[data-empty]'),live:this.q('[data-live]'),card:this.q('[data-card]'),kicker:this.q('[data-kicker]'),title:this.q('[data-result-title]'),reason:this.q('[data-reason]'),rname:this.q('[data-r-name]'),rhits:this.q('[data-r-hits]'),rseconds:this.q('[data-r-seconds]'),rtotal:this.q('[data-r-total]'),record:this.q('[data-record]'),share:this.q('[data-share]'),shareStatus:this.q('[data-share-status]')};this.e.name.value=get('tc32_mr_player');this.bind();this.rank();this.sound()}
bind(){this.e.form.addEventListener('submit',e=>{e.preventDefault();this.start()});this.e.retry.addEventListener('click',()=>this.start());this.e.share.addEventListener('click',()=>this.shareRecord());this.e.sound.addEventListener('click',async()=>{this.a.m=!this.a.m;set('tc32_mr_muted',this.a.m);if(!this.a.m)await this.a.unlock();this.sound()});this.e.arena.addEventListener('pointerdown',e=>{if(this.phase!=='playing')return;e.preventDefault();const pressed=e.target.closest('[data-target]');if(pressed){if(this.active)this.hit();return}this.end(false,'outside')});this.e.clear.addEventListener('click',()=>{if(confirm('¿Borrar todos los resultados locales de Mitt Rush?')){set('tc32_mr_ranking','[]');this.rank()}});document.addEventListener('visibilitychange',()=>{if(document.hidden&&this.phase==='playing')this.end(false,'focus')});window.addEventListener('blur',()=>{if(this.phase==='playing')this.end(false,'focus')})}sound(){this.e.sound.setAttribute('aria-pressed',this.a.m);this.e.sound.innerHTML=this.a.m?'◖× <span>SILENCIO</span>':'◖)) <span>SONIDO</span>'}
async start(){if(this.phase==='countdown'||this.phase==='playing')return;const n=this.e.name.value.trim().replace(/\s+/g,' ').slice(0,18).toUpperCase();if(!n){this.e.name.focus();return}this.player=n;set('tc32_mr_player',n);await this.a.unlock().catch(()=>{});this.reset();this.e.intro.hidden=true;this.e.results.hidden=true;this.e.game.hidden=false;this.phase='countdown';this.round=parseInt(get('tc32_mr_rounds','0'),10)+1;set('tc32_mr_rounds',this.round);this.e.round.textContent='#'+String(this.round).padStart(6,'0');this.e.time.textContent='03:00.00';this.e.hits.textContent='0';this.e.level.textContent='1';this.e.game.scrollIntoView({behavior:'smooth',block:'start'});for(const n of[3,2,1]){this.e.count.textContent=n;this.e.count.classList.remove('pop');void this.e.count.offsetWidth;this.e.count.classList.add('pop');this.a.beep(n);await wait(300)}this.e.count.textContent='';await wait(200);if(this.phase!=='countdown')return;this.a.bell();this.begin()}
begin(){this.phase='playing';this.h=0;this.l=1;this.warn=false;this.startAt=performance.now();this.endAt=this.startAt+C.duration;this.tick();this.spawnTimer=setTimeout(()=>this.spawn(),150)}tick(){if(this.phase!=='playing')return;const left=this.endAt-performance.now();this.e.time.textContent=clock(left);if(left<=10000&&!this.warn){this.warn=true;this.a.clacks();this.e.game.classList.add('final');this.e.final.classList.add('show')}if(left<=0){this.end(true,'complete');return}this.raf=requestAnimationFrame(()=>this.tick())}delay(){return Math.max(C.delay-Math.floor(this.h/C.every)*C.step,C.min)}reaction(){return Math.max(C.reactionStart-Math.floor(this.h/C.every)*C.reactionStep,C.reactionMin)}
spawn(){if(this.phase!=='playing')return;const b=this.e.arena.getBoundingClientRect(),d=Math.floor(this.h/C.every),s=Math.max(76,118-d*2.4),half=s*.58,top=Math.max(70,half+10),x=half+10+Math.random()*Math.max(1,b.width-(half+10)*2),y=top+Math.random()*Math.max(1,b.height-top-half-15);Object.assign(this.e.target.style,{width:s+'px',height:s*1.14+'px',left:x+'px',top:y+'px'});this.e.target.style.setProperty('--r',(-18+Math.random()*36)+'deg');this.e.target.classList.remove('hit');this.e.target.classList.add('active');this.active=true;this.shown=performance.now();this.targetTimer=setTimeout(()=>{if(this.phase==='playing'&&this.active){if(performance.now()>=this.endAt)this.end(true,'complete');else this.end(false,'slow')}},this.reaction()+C.grace)}
hit(){if(this.phase!=='playing')return;if(!this.active){this.end(false,'outside');return}const t=performance.now()-this.shown;if(t>this.reaction()+C.grace){this.end(false,'slow');return}clearTimeout(this.targetTimer);this.active=false;this.h++;this.l=Math.floor(this.h/C.every)+1;this.e.hits.textContent=this.h;this.e.level.textContent=this.l;this.a.hit(t);if(navigator.vibrate)navigator.vibrate(t<=250?32:18);const b=this.e.target.getBoundingClientRect(),a=this.e.arena.getBoundingClientRect();this.e.feedback.textContent=t<=250?'PERFECT':t<=550?'FAST':'HIT';this.e.feedback.style.left=b.left-a.left+b.width/2+'px';this.e.feedback.style.top=Math.max(65,b.top-a.top)+'px';this.e.feedback.classList.remove('show');void this.e.feedback.offsetWidth;this.e.feedback.classList.add('show');this.e.target.classList.remove('active');this.e.target.classList.add('hit');this.e.flash.classList.remove('hit');void this.e.flash.offsetWidth;this.e.flash.classList.add('hit');if(this.h%C.every===0){this.e.levelUp.textContent='VELOCIDAD +1 · NIVEL '+this.l;this.e.levelUp.classList.remove('show');void this.e.levelUp.offsetWidth;this.e.levelUp.classList.add('show')}this.spawnTimer=setTimeout(()=>{this.e.target.classList.remove('hit');this.spawn()},this.delay())}
end(done,why){if(this.phase!=='playing')return;const now=performance.now();this.phase='ended';cancelAnimationFrame(this.raf);clearTimeout(this.targetTimer);clearTimeout(this.spawnTimer);this.active=false;this.e.target.classList.remove('active','hit');const seconds=done?180:Math.max(.01,Math.min(180,(now-this.startAt)/1000)),total=Math.round(this.h*seconds),entry={name:this.player,hits:this.h,seconds:Number(seconds.toFixed(2)),total,round:this.round,completed:done,date:Date.now()},record=this.save(entry);if(done){this.e.time.textContent='00:00.00';this.a.bell();setTimeout(()=>this.a.crowd(),260);this.confetti()}else{this.a.ko();if(navigator.vibrate)navigator.vibrate(150);this.e.flash.classList.add('miss')}setTimeout(()=>this.result(entry,why,record),done?900:380)}
save(e){const r=json(get('tc32_mr_ranking','[]'),[]),best=r.length?Math.max(...r.map(x=>Number(x.total)||0)):-1;r.push(e);r.sort((a,b)=>b.total-a.total||b.seconds-a.seconds||b.hits-a.hits);set('tc32_mr_ranking',JSON.stringify(r.slice(0,10)));return e.total>best}result(e,w,record){const reasons={slow:'La manopla desapareció antes del golpe.',outside:'Tocaste fuera de la manopla.',focus:'La ventana perdió el enfoque.',complete:'Sobreviviste el round completo.'};this.e.game.hidden=true;this.e.results.hidden=false;this.e.card.classList.toggle('victory',e.completed);this.e.kicker.textContent=e.completed?'ROUND COMPLETO':'KO';this.e.title.textContent=e.completed?'LO LOGRASTE':'ROUND TERMINADO';this.e.reason.textContent=reasons[w]||'';this.e.rname.textContent=e.name;this.e.rhits.textContent=e.hits;this.e.rseconds.textContent=e.seconds.toFixed(2);this.e.rtotal.textContent=e.total.toLocaleString('es-MX');this.e.record.hidden=!record;this.lastEntry=e;this.e.shareStatus.textContent='';this.e.share.querySelector('span').textContent='COMPARTIR RÉCORD';this.e.live.textContent=(e.completed?'Round completo. ':'KO. ')+e.hits+' golpes, '+e.seconds.toFixed(2)+' segundos, total '+e.total;this.rank();this.e.results.scrollIntoView({behavior:'smooth',block:'start'})}
async shareRecord(){if(!this.lastEntry)return;const e=this.lastEntry,score=Number(e.total).toLocaleString('es-MX'),url=window.location.origin+window.location.pathname,text='¡Logré una puntuación de '+score+' en Mitt Rush de TC32! Te reto a que me superes.';try{if(navigator.share){await navigator.share({title:'Mitt Rush | TC32 Arcade',text,url});this.e.shareStatus.textContent='RÉCORD COMPARTIDO';return}const full=text+' '+url;if(navigator.clipboard&&window.isSecureContext){await navigator.clipboard.writeText(full)}else{const area=document.createElement('textarea');area.value=full;area.setAttribute('readonly','');area.style.position='fixed';area.style.opacity='0';document.body.appendChild(area);area.select();document.execCommand('copy');area.remove()}this.e.share.querySelector('span').textContent='ENLACE COPIADO';this.e.shareStatus.textContent='MENSAJE COPIADO. PÉGALO EN WHATSAPP, INSTAGRAM O DONDE QUIERAS.';setTimeout(()=>{if(this.e.share){this.e.share.querySelector('span').textContent='COMPARTIR RÉCORD';this.e.shareStatus.textContent=''}},3500)}catch(err){if(err&&err.name==='AbortError')return;this.e.shareStatus.textContent='NO FUE POSIBLE COMPARTIR. INTÉNTALO DE NUEVO.'}}
confetti(){this.e.confetti.replaceChildren();const c=['#f4b400','#fff','#111'];for(let n=0;n<150;n++){const i=document.createElement('i');i.style.left=Math.random()*100+'%';i.style.setProperty('--w',5+Math.random()*10+'px');i.style.setProperty('--h',10+Math.random()*18+'px');i.style.setProperty('--c',c[n%3]);i.style.setProperty('--d',2.7+Math.random()*2.8+'s');i.style.setProperty('--delay',Math.random()*.8+'s');i.style.setProperty('--drift',-150+Math.random()*300+'px');i.style.setProperty('--spin',360+Math.random()*1080+'deg');this.e.confetti.appendChild(i)}}rank(){const r=json(get('tc32_mr_ranking','[]'),[]);this.e.ranking.replaceChildren();this.e.empty.hidden=!!r.length;r.forEach((x,n)=>{const tr=document.createElement('tr');[n+1,x.name,x.hits,Number(x.seconds).toFixed(2),Number(x.total).toLocaleString('es-MX')].forEach(v=>{const td=document.createElement('td');td.textContent=v;tr.appendChild(td)});this.e.ranking.appendChild(tr)})}reset(){cancelAnimationFrame(this.raf);clearTimeout(this.targetTimer);clearTimeout(this.spawnTimer);this.e.target.classList.remove('active','hit');this.e.game.classList.remove('final');this.e.final.classList.remove('show');this.e.levelUp.classList.remove('show');this.e.feedback.classList.remove('show');this.e.flash.classList.remove('hit','miss');this.e.confetti.replaceChildren()}}
const init=s=>(s||document).querySelectorAll('[data-mitt-rush]').forEach(r=>new Game(r));document.readyState==='loading'?document.addEventListener('DOMContentLoaded',()=>init()):init();document.addEventListener('shopify:section:load',e=>init(e.target));})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tc32-quejas"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initializeTC32Complaints = () => {
      document
        .querySelectorAll('[data-complaint-form]')
        .forEach((form) => {
          if (form.dataset.initialized === 'true') return;
          form.dataset.initialized = 'true';

          const section = form.closest('.tc32-quejas');

          const productSearch = form.querySelector(
            '[data-product-search]'
          );

          const productResults = form.querySelector(
            '[data-product-results]'
          );

          const searchSpinner = form.querySelector(
            '[data-search-spinner]'
          );

          const productError = form.querySelector(
            '[data-product-error]'
          );

          const selectedProductWrapper = form.querySelector(
            '[data-selected-product-wrapper]'
          );

          const selectedProductImage = form.querySelector(
            '[data-selected-product-image]'
          );

          const selectedProductTitle = form.querySelector(
            '[data-selected-product-title]'
          );

          const changeProductButton = form.querySelector(
            '[data-change-product]'
          );

          const variantWrapper = form.querySelector(
            '[data-variant-wrapper]'
          );

          const variantSelect = form.querySelector(
            '[data-variant-select]'
          );

          const variantError = form.querySelector(
            '[data-variant-error]'
          );

          const variantSummaryWrapper = form.querySelector(
            '[data-variant-summary-wrapper]'
          );

          const variantSummaryTitle = form.querySelector(
            '[data-variant-summary-title]'
          );

          const variantSummaryOptions = form.querySelector(
            '[data-variant-summary-options]'
          );

          const variantSummarySku = form.querySelector(
            '[data-variant-summary-sku]'
          );

          const hiddenProductFields = {
            id: form.querySelector('[data-product-id]'),
            title: form.querySelector('[data-product-title]'),
            handle: form.querySelector('[data-product-handle]'),
            url: form.querySelector('[data-product-url]'),
            image: form.querySelector('[data-product-image]')
          };

          const hiddenVariantFields = {
            id: form.querySelector('[data-variant-id]'),
            title: form.querySelector('[data-variant-title]'),
            sku: form.querySelector('[data-variant-sku]'),
            barcode: form.querySelector('[data-variant-barcode]'),
            option1Name: form.querySelector('[data-option-1-name]'),
            option1Value: form.querySelector('[data-option-1-value]'),
            option2Name: form.querySelector('[data-option-2-name]'),
            option2Value: form.querySelector('[data-option-2-value]'),
            option3Name: form.querySelector('[data-option-3-name]'),
            option3Value: form.querySelector('[data-option-3-value]')
          };

          const salesChannel = form.querySelector(
            '[data-sales-channel]'
          );

          const storeNameWrapper = form.querySelector(
            '[data-store-name-wrapper]'
          );

          const storeName = form.querySelector(
            '[data-store-name]'
          );

          const damageCheckboxes = [
            ...form.querySelectorAll('[data-damage-checkbox]')
          ];

          const damageError = form.querySelector(
            '[data-damage-error]'
          );

          const otherDamageWrapper = form.querySelector(
            '[data-other-damage-wrapper]'
          );

          const otherDamage = form.querySelector(
            '[data-other-damage]'
          );

          const comments = form.querySelector('[data-comments]');
          const characterCount = form.querySelector(
            '[data-character-count]'
          );

          const fileInput = form.querySelector('[data-file-input]');
          const fileList = form.querySelector('[data-file-list]');
          const fileError = form.querySelector('[data-file-error]');

          const consentCheckboxes = [
            ...form.querySelectorAll('[data-required-consent]')
          ];

          const consentError = form.querySelector(
            '[data-consent-error]'
          );

          const purchaseDate = form.querySelector(
            '[data-purchase-date]'
          );

          const submittedAt = form.querySelector(
            '[data-submitted-at]'
          );

          const submitButton = form.querySelector(
            '[data-submit-button]'
          );

          const submitText = form.querySelector(
            '[data-submit-text]'
          );

          const submitSpinner = form.querySelector(
            '[data-submit-spinner]'
          );

          const successMessage = section.querySelector(
            '[data-success-message]'
          );

          const generalError = section.querySelector(
            '[data-general-error]'
          );

          const generalErrorText = section.querySelector(
            '[data-general-error-text]'
          );

          const folioElement = section.querySelector('[data-folio]');

          let searchTimer = null;
          let searchController = null;
          let currentProduct = null;
          let currentProductOptions = [];
          let currentVariants = [];

          const escapeHtml = (value = '') => {
            const element = document.createElement('div');
            element.textContent = value;
            return element.innerHTML;
          };

          const setHiddenValue = (field, value) => {
            if (field) field.value = value ?? '';
          };

          const clearVariantData = () => {
            currentVariants = [];
            currentProductOptions = [];

            Object.values(hiddenVariantFields).forEach((field) => {
              setHiddenValue(field, '');
            });

            variantSelect.innerHTML =
              '<option value="">Selecciona una variante</option>';

            variantSelect.disabled = true;
            variantWrapper.hidden = true;
            variantSummaryWrapper.hidden = true;
            variantError.textContent = '';
          };

          const clearProductData = () => {
            currentProduct = null;

            Object.values(hiddenProductFields).forEach((field) => {
              setHiddenValue(field, '');
            });

            clearVariantData();

            selectedProductWrapper.hidden = true;
            productError.textContent = '';
          };

          const getProductImage = (product) => {
            if (typeof product.featured_image === 'string') {
              return product.featured_image;
            }

            if (product.featured_image?.url) {
              return product.featured_image.url;
            }

            if (typeof product.image === 'string') {
              return product.image;
            }

            return '';
          };

          const closeResults = () => {
            productResults.hidden = true;
            productResults.innerHTML = '';
          };

          const renderSearchResults = (products) => {
            productResults.innerHTML = '';

            if (!products.length) {
              productResults.innerHTML = `
                <div class="tc32-product-results__empty">
                  No se encontraron productos activos con ese nombre.
                </div>
              `;

              productResults.hidden = false;
              return;
            }

            products.forEach((product) => {
              const button = document.createElement('button');
              button.type = 'button';
              button.className = 'tc32-product-result';

              const image =
                product.featured_image?.url ||
                product.featured_image ||
                product.image ||
                '';

              button.innerHTML = `
                ${
                  image
                    ? `<img src="${escapeHtml(image)}" alt="">`
                    : '<div></div>'
                }

                <span class="tc32-product-result__content">
                  <strong>${escapeHtml(product.title)}</strong>
                  <span>Producto oficial TC32</span>
                </span>

                <svg viewBox="0 0 24 24" aria-hidden="true">
                  <path d="m13 5-1.4 1.4 4.6 4.6H4v2h12.2l-4.6 4.6L13 19l7-7-7-7Z"/>
                </svg>
              `;

              button.addEventListener('click', () => {
                selectProduct(product);
              });

              productResults.appendChild(button);
            });

            productResults.hidden = false;
          };

          const searchProducts = async (query) => {
            const cleanQuery = query.trim();

            if (cleanQuery.length < 2) {
              closeResults();
              return;
            }

            if (searchController) searchController.abort();
            searchController = new AbortController();

            searchSpinner.hidden = false;

            try {
              const url =
                `/search/suggest.json?q=${encodeURIComponent(cleanQuery)}` +
                '&resources[type]=product' +
                '&resources[limit]=8' +
                '&resources[options][unavailable_products]=show';

              const response = await fetch(url, {
                headers: {
                  Accept: 'application/json'
                },
                signal: searchController.signal
              });

              if (!response.ok) {
                throw new Error('No se pudo consultar el catálogo.');
              }

              const data = await response.json();

              const products =
                data?.resources?.results?.products || [];

              renderSearchResults(products);
            } catch (error) {
              if (error.name === 'AbortError') return;

              productResults.innerHTML = `
                <div class="tc32-product-results__empty">
                  No fue posible consultar el catálogo. Inténtalo nuevamente.
                </div>
              `;

              productResults.hidden = false;
            } finally {
              searchSpinner.hidden = true;
            }
          };

          const loadProductJSON = async (product) => {
            const productUrl = new URL(
              product.url,
              window.location.origin
            );

            const pathname = productUrl.pathname.replace(/\/$/, '');

            const response = await fetch(`${pathname}.js`, {
              headers: {
                Accept: 'application/json'
              }
            });

            if (!response.ok) {
              throw new Error(
                'No fue posible cargar las variantes del producto.'
              );
            }

            return response.json();
          };

          const populateVariants = (productData) => {
            currentProductOptions = Array.isArray(productData.options)
              ? productData.options.map((option) => {
                  if (typeof option === 'string') {
                    return option;
                  }

                  return option.name || '';
                })
              : [];

            currentVariants = Array.isArray(productData.variants)
              ? productData.variants
              : [];

            variantSelect.innerHTML =
              '<option value="">Selecciona una variante</option>';

            currentVariants.forEach((variant) => {
              const option = document.createElement('option');

              option.value = String(variant.id);
              option.textContent =
                variant.title === 'Default Title'
                  ? productData.title
                  : variant.title;

              variantSelect.appendChild(option);
            });

            variantSelect.disabled = false;
            variantWrapper.hidden = false;

            if (currentVariants.length === 1) {
              variantSelect.value = String(currentVariants[0].id);
              selectVariant(currentVariants[0]);
            }
          };

          const selectProduct = async (product) => {
            closeResults();
            clearProductData();

            productSearch.value = product.title;
            productSearch.disabled = true;
            productError.textContent = '';

            selectedProductTitle.textContent = product.title;

            const previewImage =
              product.featured_image?.url ||
              product.featured_image ||
              product.image ||
              '';

            if (previewImage) {
              selectedProductImage.src = previewImage;
              selectedProductImage.alt = product.title;
              selectedProductImage.hidden = false;
            } else {
              selectedProductImage.hidden = true;
            }

            selectedProductWrapper.hidden = false;

            try {
              const productData = await loadProductJSON(product);

              currentProduct = productData;

              const productImage =
                getProductImage(productData) || previewImage;

              setHiddenValue(
                hiddenProductFields.id,
                productData.id
              );

              setHiddenValue(
                hiddenProductFields.title,
                productData.title
              );

              setHiddenValue(
                hiddenProductFields.handle,
                productData.handle
              );

              setHiddenValue(
                hiddenProductFields.url,
                product.url
              );

              setHiddenValue(
                hiddenProductFields.image,
                productImage
              );

              if (productImage) {
                selectedProductImage.src = productImage;
                selectedProductImage.alt = productData.title;
                selectedProductImage.hidden = false;
              }

              selectedProductTitle.textContent = productData.title;

              populateVariants(productData);
            } catch (error) {
              productSearch.disabled = false;
              clearProductData();

              productError.textContent =
                error.message ||
                'No fue posible cargar el producto seleccionado.';
            }
          };

          const selectVariant = (variant) => {
            if (!variant) {
              Object.values(hiddenVariantFields).forEach((field) => {
                setHiddenValue(field, '');
              });

              variantSummaryWrapper.hidden = true;
              return;
            }

            const optionValues = Array.isArray(variant.options)
              ? variant.options
              : [
                  variant.option1,
                  variant.option2,
                  variant.option3
                ].filter(Boolean);

            setHiddenValue(hiddenVariantFields.id, variant.id);
            setHiddenValue(hiddenVariantFields.title, variant.title);
            setHiddenValue(hiddenVariantFields.sku, variant.sku);
            setHiddenValue(
              hiddenVariantFields.barcode,
              variant.barcode
            );

            setHiddenValue(
              hiddenVariantFields.option1Name,
              currentProductOptions[0] || ''
            );

            setHiddenValue(
              hiddenVariantFields.option1Value,
              optionValues[0] || ''
            );

            setHiddenValue(
              hiddenVariantFields.option2Name,
              currentProductOptions[1] || ''
            );

            setHiddenValue(
              hiddenVariantFields.option2Value,
              optionValues[1] || ''
            );

            setHiddenValue(
              hiddenVariantFields.option3Name,
              currentProductOptions[2] || ''
            );

            setHiddenValue(
              hiddenVariantFields.option3Value,
              optionValues[2] || ''
            );

            variantSummaryTitle.textContent =
              variant.title === 'Default Title'
                ? currentProduct.title
                : variant.title;

            const optionDescriptions = optionValues
              .map((value, index) => {
                const optionName =
                  currentProductOptions[index] ||
                  `Opción ${index + 1}`;

                return `<span><b>${escapeHtml(optionName)}:</b> ${escapeHtml(value)}</span>`;
              })
              .join('<br>');

            variantSummaryOptions.innerHTML = optionDescriptions;

            variantSummarySku.textContent = variant.sku
              ? `SKU: ${variant.sku}`
              : 'Variante registrada directamente desde Shopify';

            variantSummaryWrapper.hidden = false;
            variantError.textContent = '';
          };

          const updateSalesChannel = () => {
            const requiresStoreName = [
              'Distribuidor autorizado',
              'Otra tienda'
            ].includes(salesChannel.value);

            storeNameWrapper.hidden = !requiresStoreName;
            storeName.required = requiresStoreName;

            if (!requiresStoreName) {
              storeName.value = '';
              storeName.closest('.tc32-field')
                ?.classList.remove('is-invalid');
            }
          };

          const updateOtherDamage = () => {
            const otherSelected = damageCheckboxes.some(
              (checkbox) =>
                checkbox.checked && checkbox.value === 'Otro'
            );

            otherDamageWrapper.hidden = !otherSelected;
            otherDamage.required = otherSelected;

            if (!otherSelected) {
              otherDamage.value = '';
              otherDamage.closest('.tc32-field')
                ?.classList.remove('is-invalid');
            }
          };

          const clearFieldError = (input) => {
            const field = input.closest('.tc32-field');
            if (!field) return;

            field.classList.remove('is-invalid');

            const error = field.querySelector('[data-field-error]');
            if (error) error.textContent = '';
          };

          const setFieldError = (input, message) => {
            const field = input.closest('.tc32-field');
            if (!field) return;

            field.classList.add('is-invalid');

            const error = field.querySelector('[data-field-error]');
            if (error) error.textContent = message;
          };

          const validateStandardField = (input) => {
            if (
              input.disabled ||
              input.closest('[hidden]') ||
              input.type === 'hidden' ||
              input.classList.contains('tc32-honeypot')
            ) {
              return true;
            }

            clearFieldError(input);

            if (input.required && !input.value.trim()) {
              setFieldError(input, 'Este campo es obligatorio.');
              return false;
            }

            if (
              input.type === 'email' &&
              input.value &&
              !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(input.value)
            ) {
              setFieldError(
                input,
                'Ingresa un correo electrónico válido.'
              );

              return false;
            }

            if (
              input.name === 'comments' &&
              input.value.trim().length < 20
            ) {
              setFieldError(
                input,
                'Agrega por lo menos 20 caracteres.'
              );

              return false;
            }

            return true;
          };

          const validateProduct = () => {
            productError.textContent = '';

            if (
              !hiddenProductFields.id.value ||
              !currentProduct
            ) {
              productError.textContent =
                'Selecciona un producto del catálogo oficial.';

              return false;
            }

            return true;
          };

          const validateVariant = () => {
            variantError.textContent = '';

            if (!hiddenVariantFields.id.value) {
              variantError.textContent =
                'Selecciona la variante exacta que compraste.';

              return false;
            }

            return true;
          };

          const validateDamage = () => {
            damageError.textContent = '';

            if (
              !damageCheckboxes.some(
                (checkbox) => checkbox.checked
              )
            ) {
              damageError.textContent =
                'Selecciona por lo menos un tipo de daño.';

              return false;
            }

            return true;
          };

          const validateConsent = () => {
            consentError.textContent = '';

            if (
              consentCheckboxes.some(
                (checkbox) => !checkbox.checked
              )
            ) {
              consentError.textContent =
                'Debes aceptar ambas confirmaciones.';

              return false;
            }

            return true;
          };

          const validateFiles = () => {
            if (!fileInput) return true;

            fileError.textContent = '';

            const files = [...fileInput.files];
            const maximum = Number(
              fileInput.dataset.maxFiles || 5
            );

            const allowedTypes = [
              'image/jpeg',
              'image/png',
              'image/webp'
            ];

            const maximumSize = 8 * 1024 * 1024;

            if (files.length > maximum) {
              fileError.textContent =
                `Puedes adjuntar un máximo de ${maximum} archivos.`;

              return false;
            }

            if (
              files.some(
                (file) => !allowedTypes.includes(file.type)
              )
            ) {
              fileError.textContent =
                'Solo se permiten imágenes JPG, PNG o WEBP.';

              return false;
            }

            if (
              files.some((file) => file.size > maximumSize)
            ) {
              fileError.textContent =
                'Cada imagen debe pesar menos de 8 MB.';

              return false;
            }

            return true;
          };

          const validateForm = () => {
            let valid = true;

            form
              .querySelectorAll(
                'input:not([type="checkbox"]):not([type="file"]), select, textarea'
              )
              .forEach((input) => {
                if (!validateStandardField(input)) {
                  valid = false;
                }
              });

            if (!validateProduct()) valid = false;
            if (!validateVariant()) valid = false;
            if (!validateDamage()) valid = false;
            if (!validateConsent()) valid = false;
            if (!validateFiles()) valid = false;

            return valid;
          };

          const renderFiles = () => {
            if (!fileInput || !fileList) return;

            fileList.innerHTML = '';

            [...fileInput.files].forEach((file) => {
              const item = document.createElement('div');
              item.className = 'tc32-file-item';

              const name = document.createElement('span');
              name.textContent = file.name;

              const size = document.createElement('span');
              size.textContent =
                `${(file.size / 1024 / 1024).toFixed(2)} MB`;

              item.append(name, size);
              fileList.appendChild(item);
            });

            validateFiles();
          };

          const setLoading = (loading) => {
            submitButton.disabled = loading;
            submitSpinner.hidden = !loading;

            submitText.textContent = loading
              ? 'Enviando...'
              : 'Enviar queja';
          };

          productSearch.addEventListener('input', () => {
            if (currentProduct) {
              clearProductData();
            }

            clearTimeout(searchTimer);

            searchTimer = setTimeout(() => {
              searchProducts(productSearch.value);
            }, 300);
          });

          productSearch.addEventListener('focus', () => {
            if (
              productSearch.value.trim().length >= 2 &&
              !currentProduct
            ) {
              searchProducts(productSearch.value);
            }
          });

          changeProductButton.addEventListener('click', () => {
            clearProductData();
            productSearch.disabled = false;
            productSearch.value = '';
            productSearch.focus();
          });

          variantSelect.addEventListener('change', () => {
            const variant = currentVariants.find(
              (item) =>
                String(item.id) === String(variantSelect.value)
            );

            selectVariant(variant);
          });

          salesChannel.addEventListener(
            'change',
            updateSalesChannel
          );

          damageCheckboxes.forEach((checkbox) => {
            checkbox.addEventListener('change', () => {
              damageError.textContent = '';
              updateOtherDamage();
            });
          });

          comments.addEventListener('input', () => {
            characterCount.textContent = comments.value.length;
          });

          fileInput?.addEventListener('change', renderFiles);

          form
            .querySelectorAll('input, select, textarea')
            .forEach((input) => {
              input.addEventListener('input', () => {
                if (
                  input.type !== 'checkbox' &&
                  input.type !== 'file'
                ) {
                  clearFieldError(input);
                }
              });
            });

          document.addEventListener('click', (event) => {
            if (
              !event.target.closest('[data-product-search-wrapper]')
            ) {
              closeResults();
            }
          });

          form.addEventListener('submit', async (event) => {
            event.preventDefault();

            successMessage.hidden = true;
            generalError.hidden = true;

            if (!validateForm()) {
              const firstInvalid =
                form.querySelector(
                  '.is-invalid input, .is-invalid select, .is-invalid textarea'
                );

              if (firstInvalid) {
                firstInvalid.focus();
              } else if (!hiddenProductFields.id.value) {
                productSearch.focus();
              } else if (!hiddenVariantFields.id.value) {
                variantSelect.focus();
              }

              return;
            }

            submittedAt.value = new Date().toISOString();
            setLoading(true);

            try {
              const response = await fetch(form.action, {
                method: 'POST',
                body: new FormData(form),
                headers: {
                  Accept: 'application/json'
                }
              });

              let result = {};

              try {
                result = await response.json();
              } catch (error) {
                result = {};
              }

              if (!response.ok || result.success === false) {
                throw new Error(
                  result.message ||
                  'No fue posible registrar la queja.'
                );
              }

              folioElement.textContent =
                result.folio ||
                `TC32-${Date.now().toString().slice(-8)}`;

              form.reset();
              clearProductData();

              productSearch.disabled = false;
              productSearch.value = '';

              if (fileList) fileList.innerHTML = '';
              characterCount.textContent = '0';

              updateSalesChannel();
              updateOtherDamage();

              successMessage.hidden = false;
              successMessage.focus();
              successMessage.scrollIntoView({
                behavior: 'smooth',
                block: 'center'
              });
            } catch (error) {
              generalErrorText.textContent =
                error.message ||
                'Revisa la información e inténtalo nuevamente.';

              generalError.hidden = false;
              generalError.focus();
              generalError.scrollIntoView({
                behavior: 'smooth',
                block: 'center'
              });
            } finally {
              setLoading(false);
            }
          });

          const today = new Date();
          const year = today.getFullYear();
          const month = String(
            today.getMonth() + 1
          ).padStart(2, '0');

          const day = String(today.getDate()).padStart(2, '0');

          purchaseDate.max = `${year}-${month}-${day}`;

          updateSalesChannel();
          updateOtherDamage();
        });
    };

    document.addEventListener(
      'DOMContentLoaded',
      initializeTC32Complaints
    );

    document.addEventListener(
      'shopify:section:load',
      initializeTC32Complaints
    );

    initializeTC32Complaints();
  })();

  } catch(e) { console.error(e); }
})();
})();
